import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DataTable from "examples/Tables/DataTable";
import { useEffect, useState } from "react";
import { getConsumptionSummaryCall } from "../../api/api";
import { Pagination } from "@mui/material";
import MobileNavbar from "examples/Navbars/MobileNavbar";
import { useIsMobile } from "hooks/useIsMobile";
import getConsumptionSummaryTableData from "./data/table_data";
import TotalsView from "components/totals_view";
import formatCurrency from "helpers/formatCurrency";
import MDButton from "components/MDButton";
import NotEnteredAccounts from "./not_entered_accounts";

function ConsumptionSummary() {
  const [state, setState] = useState({
    columns: [],
    rows: [],
    page: 1,
    totalPages: 1,
    totalAmount: 0,
    coverage: "",
    showNotEnteredAccounts: false,
    notEnteredAccounts: [],
  });

  const isMobile = useIsMobile();

  const getConsumptionSummary = async ({ page }) => {
    const response = await getConsumptionSummaryCall({ page });
    if (response) {
      const { page, totalPages, accounts, totalAmount, coverage, notEnteredAccounts } = response;
      const { columns, rows } = getConsumptionSummaryTableData(accounts);
      setState({
        ...state,
        columns,
        rows,
        page,
        totalPages,
        totalAmount,
        coverage,
        notEnteredAccounts,
      });
    }
  };

  useEffect(() => {
    const { page } = state;
    getConsumptionSummary({ page });
  }, [state.page]);

  const setShowNotEnteredAccounts = (status) => {
    setState({ ...state, showNotEnteredAccounts: status });
  };

  return (
    <DashboardLayout>
      <MobileNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={2}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems={isMobile ? "left" : "center"}
                flexDirection={isMobile ? "column" : "row"}
                gap={isMobile ? 1 : 0}
              >
                <MDTypography variant="h6" color="white">
                  Consumption Summary
                </MDTypography>
                <MDBox display="flex" flexDirection={isMobile ? "column" : "row"} gap={1}>
                  <MDButton
                    color="dark"
                    variant="gradient"
                    onClick={() => setShowNotEnteredAccounts(true)}
                    style={{
                      width:'fit-content'
                    }}
                  >
                    Missing Records
                  </MDButton>
                  <TotalsView title={"Coverage"} amount={state.coverage} variant="warning" />
                  <TotalsView
                    title={"Total Amount"}
                    amount={formatCurrency(state.totalAmount)}
                    variant="success"
                  />
                </MDBox>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns: state.columns, rows: state.rows }}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                />
                <Pagination
                  style={{
                    justifySelf: "right",
                    margin: 10,
                  }}
                  variant="outlined"
                  shape="rounded"
                  count={state.totalPages}
                  page={state.page}
                  onChange={(e, page) => {
                    setState({ ...state, page });
                  }}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <NotEnteredAccounts
        open={state.showNotEnteredAccounts}
        setOpen={setShowNotEnteredAccounts}
        accounts={state.notEnteredAccounts}
      />
    </DashboardLayout>
  );
}

export default ConsumptionSummary;
